import { makeStyles } from 'tss-react/mui';

export const HEADER_HEIGHT = 64;

const useStyles = makeStyles()((theme) => ({
  headerWrapper: {
    borderBottom: `1px solid ${theme.new.color.line.hairline}`,
    boxShadow: 'none',
    maxHeight: `${HEADER_HEIGHT}px`,
    zIndex: 5, // to be above the table loading overlay and notifications sticky header.
    '&.hideBar': { display: 'none' },
    // When acting on tablet/desktop, the banner sits inline within the header
    // row, which shares the brand[200] header background. (On mobile the banner
    // is rendered in the page content instead, so the header is unaffected.)
    '&.acting': {
      [theme.breakpoints.up('md')]: {
        backgroundColor: theme.new.color.brand[200],
      },
    },
  },
  // Wraps the banner and the header controls. On tablet/desktop, when acting,
  // it lays the banner (left) and controls (right) out on a single row.
  headerInner: {
    width: '100%',
    '&.acting': {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'flex-start',
    flex: '1 0 0',
    padding: '12px 16px',
    minHeight: `${HEADER_HEIGHT}px`,
    [theme.breakpoints.up('md')]: {
      padding: '12px 32px',
    },
    // Keep the header controls layered above the banner backdrop.
    '&.acting': {
      position: 'relative',
      zIndex: 1,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '24px',
    width: '100%',
  },
  ciDemoBadge: {
    backgroundColor: '#FF0000',
    color: '#000000',
    padding: '4px 10px',
    borderRadius: '4px',
    fontWeight: 700,
    fontSize: '0.75rem',
    letterSpacing: '0.05em',
  },
  backToHomeLink: {
    marginRight: 'auto',
  },
  profileContainerButton: {
    borderRadius: '50%',
    height: '32px',
    minWidth: '32px',
    padding: 0,

    '&:hover, &:focus': {
      outline: `5px solid ${theme.new.color.brand[100]}`,
      outlineOffset: '0px',
    },

    '&:active': {
      outline: `5px solid ${theme.new.color.brand[200]}`,
      outlineOffset: '0px',
    },
  },
  profileContainer: {
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    padding: 0,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.new.color.line.hairline}`,
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.isOpen': {
      outline: `5px solid ${theme.new.color.brand[200]}`,
      outlineOffset: '0px',
    },
  },
}));

export default useStyles;
